export var getMis = function getMis(serverTime) {
  // 获取延时
  var ms = new Date() - serverTime;
  return ms;
};
export var getNowTime = function getNowTime(current, mistiming) {
  // 获取准确的服务器当前时间
  return current - mistiming;
};
export var caculateTapStatus = function caculateTapStatus(_ref) {
  var self = _ref.self,
    generalAgent = _ref.generalAgent,
    exclusive = _ref.exclusive;
  // 计算展示tapStatus类型
  // 非自营
  if (!self) {
    return '';
  }
  // 独家 & 总代
  if (generalAgent && exclusive) {
    return 'exclusive-agent';
  }
  // 总代
  if (generalAgent && !exclusive) {
    return 'generalAgent';
  }
  // 独家
  if (!generalAgent && exclusive) {
    return 'exclusive';
  }
};